import AuthApi from "Api/AuthApi";
import Storage from "./Storage";

// In-memory refresh mutex: the first caller starts the refresh, everyone else
// awaits the same promise. A try/finally guarantees it is cleared even on
// failure, so a broken refresh can never wedge every later check.
let refreshPromise = null;

// Heal sessions stuck behind an orphaned flag left by the previous localStorage
// based mutex.
Storage.remove('isRefreshingToken');

const AuthHelper = {

    checkForTokenRefresh: async () => {
        let tokenRefreshDate = Storage.get('token_refresh_date');
        if ( tokenRefreshDate && new Date(tokenRefreshDate).toISOString() > (new Date).toISOString() ) {
            return true;
        }

        if (refreshPromise) {
            return refreshPromise;
        }

        refreshPromise = (async () => {
            try {
                let refresh = await AuthApi.refreshToken();
                if (refresh.status === 200) {
                    Storage.set('token', refresh.json.token);
                    AuthHelper.setRefreshDate();
                    return true;
                }
                return false;
            } catch (err) {
                return false;
            } finally {
                refreshPromise = null;
            }
        })();

        return refreshPromise;
    },

    setRefreshDate: () => {
        let newRefreshDate = new Date;
        newRefreshDate.setMinutes( newRefreshDate.getMinutes() + 10 );
        Storage.set('token_refresh_date', newRefreshDate);
    },

    getBearerToken: () => {
        if (Storage.exists('token'))
            return `Bearer ${Storage.get('token')}`;
        return '';
    }
}

export default AuthHelper;
